import React from 'react';

export default function MyConsultations() {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '70vh', padding: 24, fontFamily: 'system-ui, sans-serif',
    }}>
      <div style={{ textAlign: 'center', maxWidth: 400 }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🩺</div>
        <h2 style={{ fontSize: 22, fontWeight: 800, color: '#0f172a', margin: '0 0 12px' }}>My Consultations</h2>
        <p style={{
          fontStyle: 'italic', fontSize: 18, color: '#94a3b8',
          fontFamily: "'Georgia', 'Times New Roman', serif",
          lineHeight: 1.6,
        }}>
          Coming soon...
        </p>
      </div>
    </div>
  );
}
